import { render, staticRenderFns } from "./FooterReport.vue?vue&type=template&id=5c77c19b&functional=true"
import script from "./FooterReport.vue?vue&type=script&lang=js"
export * from "./FooterReport.vue?vue&type=script&lang=js"
import style0 from "./FooterReport.vue?vue&type=style&index=0&id=5c77c19b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports